//extracted from icon-59-59-round-tick.svg
import React from 'react';
export const viewbox = '0 0 59 59.1';

export const content = (
  <>
    <defs>
      <style>
        .cls-1,.cls-3{'{fill:none;}'}.cls-2{'{fill:#009ca6;}'}.cls-3
        {'{stroke:#009ca6;stroke-miterlimit:10;}'}
      </style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <rect id="box" className="cls-1" x="15.31" width="24" height="48" />
        <path
          id="icon_checkmark"
          data-name="icon checkmark"
          className="cls-2"
          d="M45.5,20.8l-1.6-3.2A43.62,43.62,0,0,0,23.1,30.4l-6.4-4.8-3.2,3.2,9.6,12.8C30.5,27.8,45.5,20.8,45.5,20.8Z"
        />
        <path
          className="cls-3"
          d="M.5,29.6a29,29,0,1,1,29,29,29,29,0,0,1-29-29"
        />
      </g>
    </g>
  </>
);

export default { viewbox, content };
